/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/guards/app.guards.featureguard.ts.
 */
import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Route, RouterStateSnapshot, UrlSegment} from '@angular/router';
import {Observable, of} from 'rxjs';
import {AppConfigService} from '../services/app.config.service';

/**
 * Zweck: Beschreibt class AppGuardsFeatureguard und ihren Daten- oder Funktionsvertrag.
 */
@Injectable()
export class AppGuardsFeatureguard  {
/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(private cfg: AppConfigService) {
  }

/**
 * Beschreibt Methode canActivate und ihren Rückgabevertrag.
 */
  canActivate(route: ActivatedRouteSnapshot, rtsnap: RouterStateSnapshot): Observable<boolean> {
    if (route.data.features) {
      return of(this.cfg.featuresEnabled(route.data.features));
    } else {
      return of(true);
    }
  }

/**
 * Beschreibt Methode canActivateChild und ihren Rückgabevertrag.
 */
  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (childRoute.data && childRoute.data.features) {
      return of(this.cfg.featuresEnabled(childRoute.data.features));
    } else {
      return of(true);
    }
  }

/**
 * Beschreibt Methode canLoad und ihren Rückgabevertrag.
 */
  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    if (route.data && route.data.features) {
      return of(this.cfg.featuresEnabled(route.data.features));
    } else {
      return of(true);
    }
  }
}
